import {
  FEEDBACK_PLATFORMS,
  FEEDBACK_POST_TYPES,
  type FeedbackPlatform,
  type FeedbackPostType,
} from './types';

export interface NewPostInput {
  title: string;
  description: string;
  feedbackType: FeedbackPostType;
  platform: FeedbackPlatform;
  contentUrl: string;
  feedbackPrompt: string;
}

function isValidHttpUrl(s: string): boolean {
  try {
    const u = new URL(s);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}

export function validateNewFeedbackPost(input: NewPostInput): { ok: true } | { ok: false; message: string } {
  const title = input.title.trim();
  const description = input.description.trim();
  if (!title) {
    return { ok: false, message: 'Add a title so people know what you need.' };
  }
  if (title.length > 200) {
    return { ok: false, message: 'Title must be 200 characters or less.' };
  }
  if (!description) {
    return { ok: false, message: 'Describe what you want feedback on.' };
  }
  if (description.length > 8000) {
    return { ok: false, message: 'Description is too long.' };
  }
  if (!FEEDBACK_POST_TYPES.includes(input.feedbackType)) {
    return { ok: false, message: 'Choose a feedback type.' };
  }
  if (!FEEDBACK_PLATFORMS.includes(input.platform)) {
    return { ok: false, message: 'Choose a platform.' };
  }
  const url = input.contentUrl.trim();
  if (url && !isValidHttpUrl(url)) {
    return { ok: false, message: 'Content URL must be a valid http or https link.' };
  }
  const prompt = input.feedbackPrompt.trim();
  if (prompt.length > 500) {
    return { ok: false, message: 'Feedback prompt is too long (500 characters max).' };
  }
  return { ok: true };
}

export function validateCommentBody(body: string): { ok: true; body: string } | { ok: false; message: string } {
  const trimmed = body.trim();
  if (!trimmed) {
    return { ok: false, message: 'Write something before posting.' };
  }
  if (trimmed.length > 8000) {
    return { ok: false, message: 'Comment is too long.' };
  }
  return { ok: true, body: trimmed };
}
